import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=23d10f25&scoped=true&"
import script from "./CollectionList.vue?vue&type=script&lang=js&"
export * from "./CollectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d10f25",
  null
  
)

export default component.exports